import { Messages, Send } from '@components'
import { useParams } from '@solidjs/router'
import { useAuth } from '@state'
import { type Component, Show, createEffect, untrack } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import { useChannelsReads } from '../../state/channelReads/state'
import { useChannel } from './state'
import { useUi } from './state/ui'

export const Chat: Component<{
	currentChannelId?: string
	height: any,
  setIsReadOnly?: boolean,
  isMinimal?: boolean
}> = (props) => {
	const params = useParams()
	const {
		setActiveChannelId,
		isReadOnly,
		unsubscribe,
		setFocusMessageId,
		activeChannelHistoryResource,
	} = useService(useChannel)()
	const { setReady, isExpanded } = useService(useUi)()
	const { setChannelRead, channelReadDictionary } = useService(useChannelsReads)()
	const { isAdmin, isCommander } = useService(useAuth)()

  const canPostMessages = () => {
    if (props.setIsReadOnly === true) return false
    return !isReadOnly() || isAdmin() || isCommander()
  }

	createEffect(() => {
		unsubscribe()
		setActiveChannelId(props.currentChannelId)
		setFocusMessageId(params.messageId)
		setReady(false)

		if (props.currentChannelId) {
			console.log(`setting viewed channel: ${props.currentChannelId}`)
		}
	})

	createEffect(() => {
		const history = activeChannelHistoryResource()
		if (activeChannelHistoryResource.state === 'ready' && history?.length) {
			const lastMessage = history[history.length - 1]

			const z = untrack(() => channelReadDictionary())

			setChannelRead({
				channel_id: lastMessage.channel_id,
				last_read_message_id: lastMessage.id,
				is_subscribed: z[lastMessage.channel_id]?.is_subscribed ?? false,
			})
		}
	})

	return (
		<Show when={props.currentChannelId}>
			<Grid
				class={css({
					gridTemplateRows: isExpanded() ? '0fr auto' : '1fr auto',
					transition: 'grid-template-rows 0.3s cubic-bezier(0.47, 0, 0.75, 0.72)',
					height: props.height,
					gap: 0,
					position: 'relative',
				})}
			>
				<Messages isMinimal={props.isMinimal}  />
				<Show when={canPostMessages()}>
					<Send currentChannelId={props.currentChannelId} />
				</Show>
			</Grid>
		</Show>
	)
}
